<h2>RESULTADO DE LA BÚSQUEDA: <small class="text-capitalize"> {{texto}} </small></h2>
<div class="row">
    <div class="col">
        <app-peliculas-poster-grid [movies]="movies" *ngIf="movies.length > 0"></app-peliculas-poster-grid>
    </div>
</div>